export default "__VITE_ASSET__0nkCJDe1__"